export const STATUSSES = {
  wip: 'In behandeling',
  concept: 'Concept',
  sent: 'Verzonden',
};

export const REPORT_SPECIES_TYPES = {
  Sown: 'Ingezaaid',
  Spontaneous: 'Spontaan',
  'Present before': 'Eerder aanwezig',
};

export const MATERIALS = [
  'Voedselarm zuur',
  'Voedselarm zwak zuur',
  'Voedselarm basisch',
  'Voedselarm',
  'Matig voedselrijk',
  'Zeer voedselrijk',
  'Matig tot zeer voedselrijk',
];

export const SUN = [
  'Zeer zonnig',
  'Zonnig',
  'Gemiddeld',
  'Halfschaduw',
  'Schaduw',
];

export const LIME_CONTENT = [
  'Kalkrijk',
  'Neutraal',
  'Kalkarm',
];

export const MONITORING = [
  '2x per jaar',
  '3x per jaar',
  '4x per jaar',
];
